<template>
  <div class="commands">
    <vk-notification
      position="top-right"
      :messages.sync="notifications"
    ></vk-notification>
    <vk-modal :show.sync="confirmCommand">
      <vk-modal-title>Modifica comando</vk-modal-title>
      <p v-if="commandingCommandType == 'boolean'">
        Il comando "<b>{{ commandingCommandLabel }}</b>" sta per essere <b>{{ commandingCommandValue ? 'attivato' : 'disattivato' }}</b> nel device "<b>{{ commandingDeviceLabel }}</b>".
      </p>
      <p v-if="commandingCommandType == 'number'">
        Il device "<b>{{ commandingDeviceLabel }}</b>" riceverà il valore <b>{{ commandingCommandValue }}</b> per il comando "<b>{{ commandingCommandLabel }}</b>"".
      </p>
      <p>
        Continuare?
      </p>
      <p class="uk-text-right">
        <vk-button @click="confirmCommand = false; confirmCommand2 = true;">Invia</vk-button>
        <vk-button @click="confirmCommand = false; updateList();" type="primary">Annulla</vk-button>
      </p>
    </vk-modal>
    <vk-modal :show.sync="confirmCommand2">
      <vk-modal-title>Modifica comando</vk-modal-title>
      <p>
        <i>Doppia conferma</i>: si è veramente sicuri di voler inviare il comando?
      </p>
      <p class="uk-text-right">
        <vk-button @click="confirmCommand2 = false; updateList();" type="primary">Annulla</vk-button>
        <vk-button @click="doCommand">Invia</vk-button>
      </p>
    </vk-modal>
    <vk-card>
      <h1>Comandi</h1>
      <p>In questa sezione è possibile modificare i comandi inviati ai device</p>

      <p v-for="device in $store.state.userDevices" v-bind:key="device.id">
        <vk-card type="secondary" v-if="deviceCommands[device.id] != null">
          <vk-card-title>{{ device.label }}</vk-card-title>
          <form class="uk-form-stacked">
            <div class="uk-margin" v-for="command in commandsDesc" v-bind:key="device.id + '-' + command.addr">
              <div v-if="command.type == 'number'">
                <label class="uk-form-label">{{ command.label }}</label>
                <div class="uk-form-controls">
                  <input class="uk-input uk-form-width-small" v-model="deviceCommands[device.id][command.addr]" type="text" @blur="beginCommand(device, command)">
                </div>
              </div>
              <div v-if="command.type == 'boolean'">
                <h5>{{ command.label }}</h5>
                <label class="uk-switch">
                  <input type="checkbox" v-model="deviceCommands[device.id][command.addr]" @change="beginCommand(device, command)">
                  <div class="uk-switch-slider"></div>
                </label>
              </div>
            </div>
          </form>
        </vk-card>
      </p>
    </vk-card>
  </div>
</template>

<style>
  .device-id {
    font-family: monospace;
    font-size: 0.8em;
  }

  /* -----------------------------
  Switch */

  .uk-switch {
    position: relative;
    display: inline-block;
    height: 34px;
    width: 60px;
  }

  /* Hide default HTML checkbox */
  .uk-switch input {
    display:none;
  }
  /* Slider */
  .uk-switch-slider {
    background-color: rgba(0,0,0,0.22);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    border-radius: 500px;
    bottom: 0;
    cursor: pointer;
    transition-property: background-color;
    transition-duration: .2s;
    box-shadow: inset 0 0 2px rgba(0,0,0,0.07);
  }
  /* Switch pointer */
  .uk-switch-slider:before {
    content: '';
    background-color: #fff;
    position: absolute;
    width: 30px;
    height: 30px;
    left: 2px;
    bottom: 2px;
    border-radius: 50%;
    transition-property: transform, box-shadow;
    transition-duration: .2s;
  }
  /* Slider active color */
  input:checked + .uk-switch-slider {
    background-color: #39f !important;
  }
  /* Pointer active animation */
  input:checked + .uk-switch-slider:before {
    transform: translateX(26px);
  }

  /* Modifiers */
  .uk-switch-slider.uk-switch-on-off {
    background-color: #f0506e;
  }
  input:checked + .uk-switch-slider.uk-switch-on-off {
    background-color: #32d296 !important;
  }

  /* Style Modifier */
  .uk-switch-slider.uk-switch-big:before {
    transform: scale(1.2);
    box-shadow: 0 0 6px rgba(0,0,0,0.22);
  }
  .uk-switch-slider.uk-switch-small:before {
    box-shadow: 0 0 6px rgba(0,0,0,0.22);
  }
  input:checked + .uk-switch-slider.uk-switch-big:before {
    transform: translateX(26px) scale(1.2);
  }

  /* Inverse Modifier - affects only default */
  .uk-light .uk-switch-slider:not(.uk-switch-on-off) {
    background-color: rgba(255,255,255,0.22);
  }
</style>

<script>
import config from '@/config'

export default {
  name: 'managedevices',
  
  components: {},

  data () {
    return {
      deviceCommands: {},
      commandsDesc: {},
      confirmCommand: false,
      confirmCommand2: false,
      commandingDeviceID: "",
      commandingDeviceLabel: "",
      commandingCommandValue: 0,
      commandingCommandLabel: "",
      commandingCommandAddr: 0,
      commandingCommandType: "",
      notifications: []
    }
  },

  created () {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
      return
    }

    this.updateCommandsDesc()
    this.updateList()
  },
  
  methods: {
    updateCommandsDesc () {
      this.$http.get(config.API_URL + '/commandsDesc', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(
        (response) => {
          if (response.body == null) {
            this.commandsDesc = {}
          } else {
            this.commandsDesc = response.body
          }
        }, (err) => {
          console.log(err)
          this.$store.commit('LOGOUT_USER')
          localStorage.removeItem('token')
          this.$router.push('/login')
        }
      )
    },

    updateList () {
      this.$http.get(config.API_URL + '/deviceCommands', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(
        (response) => {
          if (response.body == null) {
            this.deviceCommands = {}
          } else {
            this.deviceCommands = response.body
          }
        }, (err) => {
          console.log(err)
          this.$store.commit('LOGOUT_USER')
          localStorage.removeItem('token')
          this.$router.push('/login')
        }
      )
    },

    beginCommand (device, command) {
      this.commandingDeviceID = device.id
      this.commandingDeviceLabel = device.label
      this.commandingCommandAddr = command.addr
      this.commandingCommandLabel = command.label
      this.commandingCommandType = command.type
      if (command.type == 'boolean') {
        this.commandingCommandValue = this.deviceCommands[device.id][command.addr] ? 1 : 0
      } else if (command.type == 'number') {
        this.commandingCommandValue = parseFloat(this.deviceCommands[device.id][command.addr])
      }
      this.confirmCommand = true
    },

    doCommand () {
      this.confirmCommand2 = false
      this.setCommand(
        this.commandingDeviceID,
        this.commandingCommandAddr,
        this.commandingCommandValue
      )
    },

    setCommand (device, addr, value) {
      let formData = new FormData()
      formData.append("deviceID", device)
      formData.append("addr", addr)
      formData.append("value", value)

      this.$http.post(config.API_URL + '/deviceCommands', formData, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(
        () => {
          let message = "Comando impostato con successo";
          this.notifications.push({ message: message, status: 'success' })
          this.updateList()
        }, (err) => {
          console.log(err)
          this.notifications.push({ message: 'Errore impostazione comando', status: 'danger' })
          this.updateList()
        }
      )
    }
  }
}
</script>
